import { useState } from 'react'

import procedures from '../../../data/procedures.json'
import faqs from '../../../data/faqs.json'
import { FileInfo } from '../../types'

export const FileDisplayPage = ({ fileset = 'procedures' }) => {
  let files: Record<string, FileInfo> = procedures
  let nullOption: string = 'Procedures'

  switch (fileset) {
    case 'faqs':
      files = faqs
      nullOption = 'Help Topics'
      break
  }
  const fileKeys = Object.keys(files)
  document
    .querySelector('#root')
    ?.setAttribute('style', 'background-color: white;')

  const [currentFile, setCurrentFile] = useState<string>('')

  const onChangeCurrentProcedure = (
    e: React.ChangeEvent<HTMLSelectElement>,
  ) => {
    setCurrentFile(e.target.value)
  }

  const setProcedureContent = () => {
    if (currentFile === '')
      return (
        <div>
          Use the select bar to the left to find the topic you need more help
          with.
        </div>
      )
    return (
      <div
        dangerouslySetInnerHTML={{
          __html: files[currentFile].fileContent,
        }}
      />
    )
  }

  const stylizeProcedureTitle = (file: string) => {
    const activeProcedure = files[file]

    return (
      <option
        disabled={activeProcedure.disabled}
        key={activeProcedure.fileName}
        value={activeProcedure.title}
      >
        {activeProcedure.disabled
          ? `----${activeProcedure.title}----`
          : activeProcedure.title}
      </option>
    )
  }

  return (
    <div>
      <select
        style={{ marginTop: '1rem', marginLeft: '1rem' }}
        onChange={onChangeCurrentProcedure}
      >
        <option value="">{nullOption}</option>
        {files && fileKeys.map((file) => stylizeProcedureTitle(file))}
      </select>
      <div
        style={{
          width: '60%',
          margin: '0 auto',
          paddingTop: '20px',
          backgroundColor: 'white',
        }}
      >
        {setProcedureContent()}
      </div>
    </div>
  )
}
